export default () => {
  for (const element of document.getElementsByClassName("toggleParentActive")) {
    element.addEventListener("click", () => {
      element.parentElement.classList.toggle('active')
    });
  }
}
for (const element of document.getElementsByClassName("toggleBodyFixed")) {
  element.addEventListener("click", () => {
    document.body.classList.toggle('fixed')
  });
}
